import { render, staticRenderFns } from "./formInputMenu.vue?vue&type=template&id=23ab5c8b&"
import script from "./formInputMenu.vue?vue&type=script&lang=js&"
export * from "./formInputMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports